import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      50: '#d9dde5',
      100: '#b4bccc',
      200: '#8e9ab2',
      300: '#697999',
      400: '#43577f',
      light: '#b4bccc',
      main: '#1E3666',
      dark: '#192d55',
      500: '#1E3666',
      600: '#192d55',
      700: '#0f1b33',
      800: '#192d55',
      900: '#0f1b33',
    },
    neutral: {
      50: '#F8F9FB',
      100: '#E9E9EB',
      200: '#D8D8DA',
      300: '#C3C3C5',
      400: '#A8A8AA',
      500: '#89898A',
      600: '#686869',
      700: '#49494A',
      800: '#313131',
      900: '#202020',
      main: '#202020',
    },
  },
})

export default theme
